import { AnalyticEventType, AnalyticActionEvent } from '../../analytics';
import { TrackingData } from './tracking-data';

export class TrackingEvent {
  action: AnalyticActionEvent;
  label: string;
  type: AnalyticEventType;
  data: TrackingData;

  constructor(action: AnalyticActionEvent, type: AnalyticEventType, label: string, data: TrackingData) {
    this.action = action;
    this.type = type;
    this.label = label;
    this.data = data;
  }

  getType() {
    return this.type;
  }

  getAction() {
    return this.action;
  }

  setType(type: AnalyticEventType) {
    this.type = type;
  }

  setAction(action: AnalyticActionEvent) {
    this.action = action;
  }

  setData(data: TrackingData) {
    this.data = data;
  }
}
